import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';

class ProtoypeCharacterSpeak extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            character_label: appHelper.getLocaleString("character_label"),
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }


    render() {
        return (
            <div className={`object-container`}>
                <div className="prototype customer_name_label">
                    <span>{this.state.character_label}</span>
                </div>
                <div className={`prototype character speak`} dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_CHARACTER_SPEAK_TEXT}}/>
            </div>
        );
    }
}

ProtoypeCharacterSpeak.propTypes = {
    locale: PropTypes.object,
};

ProtoypeCharacterSpeak.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProtoypeCharacterSpeak);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/ProtoypeCharacterSpeak.js
 **/